import { render, staticRenderFns } from "./RecentlyAddedCard.vue?vue&type=template&id=1d8a08e5&scoped=true"
import script from "./RecentlyAddedCard.vue?vue&type=script&lang=ts"
export * from "./RecentlyAddedCard.vue?vue&type=script&lang=ts"
import style0 from "./RecentlyAddedCard.vue?vue&type=style&index=0&id=1d8a08e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8a08e5",
  null
  
)

export default component.exports